const normalizePhone = (value = "") => value.replace(/[^\d]/g, "");

const buildPhoneLink = (value, { countryCode = "+55" } = {}) => {
  const digits = normalizePhone(value);
  if (!digits) {
    return "";
  }
  return `tel:${countryCode}${digits}`;
};

const buildEmailLink = (value = "") => {
  const trimmed = (value || "").trim();
  if (!trimmed) {
    return "";
  }
  return `mailto:${trimmed}`;
};

export { normalizePhone, buildPhoneLink, buildEmailLink };
